import { LocaleEnum } from 'schema/locale';
import { StoreCode, storeCodeSchema } from 'schema/storeCode';
import { referFriendsBoardIdSchema } from '../constants';

const { eu, uk, ukd, eud } = storeCodeSchema.enum;
const { enEU, enUK, deEU, enUkd, enEud } = LocaleEnum;

type Options = {
  isPortal: boolean;
  locale: LocaleEnum;
  store: StoreCode;
};

export function getReferFriendBoardId({ isPortal, locale, store }: Options) {
  const boardId = referFriendsBoardIdSchema.enum;

  // /members/refer-a-friend page
  if (isPortal) {
    if (store === eu || store === eud) {
      if (locale === enEU || locale === enEud) return boardId.AGEUEnglishDashboard;
      if (locale === deEU) return boardId.AGDEEnglishDashboard;
    }

    if (store === uk || store === ukd) {
      if (locale === enUK || locale === enUkd) return boardId.AGUKEnglishDashboard;
    }

    return boardId.AGEnglishDashboard;
  }

  // /campaign/refer-a-friend page
  if (locale === deEU && (store === eu || store === uk)) {
    return boardId.aggermanlandingpage;
  }

  if ((locale === enEU && store === eu) || (locale === enEud && store === eud)) {
    return boardId.ageuenglishlandingpage;
  }

  if ((locale === enUK && store === uk) || (locale === enUkd && store === ukd)) {
    return boardId.AGUKenglishlandingpage;
  }

  return boardId.agenglishlandingpage;
}
